<template>
  <section class="filter">
    <SelectSearch
      :value="staff"
      placeholder="Buscar por nome"
      value-key="id"
      value-label="fullName"
      name="staff-name"
      :search-function="onSearchStaff"
      class="filter__name"
      @input="handleStaffChange"
    />
    <HSelect
      id="staff-role"
      :value="role"
      :options="roleOptions"
      option-label="description"
      option-key="name"
      class="select-role"
      placeholder="Especialidade"
      @update:value="handleRoleChange"
    />
    <HSelect
      id="staff-status"
      :value="staffStatus"
      :options="statusOptions"
      option-label="label"
      option-key="value"
      class="filter__status"
      placeholder="Status"
      @update:value="handleStatusChange"
    />
  </section>
</template>
<script>
import { HSelect, SelectSearch } from '@/components/shared/atoms'
import { STAFF_STATUS_OPTIONS } from '@/models/channels'

export default {
  components: {
    HSelect,
    SelectSearch
  },
  props: {
    roles: {
      type: Array,
      default: () => []
    },
    onSearchStaff: {
      type: Function,
      required: true
    },
    status: {
      type: String,
      default: undefined
    }
  },
  emits: ['onChangeStaff', 'onChangeStatus', 'onChangeRole'],
  data() {
    return {
      staff: null,
      statusOptions: [...STAFF_STATUS_OPTIONS],
      role: null
    }
  },
  computed: {
    staffStatus() {
      if (!this.status) {
        return null
      }
      return this.statusOptions.find(option => option.value === this.status)
    },
    roleOptions() {
      let options = []
      if (this.roles) {
        options = [...this.roles]
      }
      options.unshift({
        name: null,
        description: 'Todos'
      })
      return options
    }
  },
  created() {
    this.statusOptions.unshift({
      label: 'Todos',
      value: null
    })
  },
  methods: {
    handleStaffChange(staff) {
      this.staff = staff
      this.$emit('onChangeStaff', staff)
    },
    handleStatusChange(status) {
      this.$emit('onChangeStatus', status.value)
    },
    handleRoleChange(role) {
      this.role = role
      this.$emit('onChangeRole', role)
    }
  }
}
</script>
<style lang="scss" scoped>
.filter {
  display: flex;
  gap: var(--gl-spacing-04);
  margin-bottom: var(--gl-spacing-04);
  &__name {
    width: 320px;
    :deep(> div) {
      height: 40px;
    }
  }
  &__status {
    max-width: 100px;
  }
}
</style>
